import script from "./ActionsCount.vue?vue&type=script&setup=true&lang=ts"
export * from "./ActionsCount.vue?vue&type=script&setup=true&lang=ts"

import "./ActionsCount.vue?vue&type=style&index=0&id=1ecbe36b&scoped=true&lang=postcss"

import exportComponent from "/var/www/rentasdhelos.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ecbe36b"]])

export default __exports__